function autogrow(): void {
    const selector = "[data-js-autogrow]"

    function resize(e: Event) {
        const el = e.currentTarget as HTMLElement
        el.style.cssText = "height:auto"
        el.style.cssText = `height: ${el.scrollHeight + 1}px` // NOTE: 1 = hard coded border width
    }

    function addEventListeners() {
        const autogrowInputs = Array.from(document.querySelectorAll(selector))

        autogrowInputs.forEach((autogrowInput: HTMLElement) => {
            autogrowInput.addEventListener("input", resize)
        })
    }

    function init() {
        addEventListeners()
    }

    init()
}

export default autogrow
